<script lang="ts">
  /**
   * The toss.
   *
   * Not cosmetic: in the source data the winner fields 66% of the time and the
   * chasing side wins 54.7% of matches, so this is a real decision with a real
   * edge — which is why the copy says so without quoting the model at it.
   */
  import type { Match } from '../lib/match.svelte';

  interface Props {
    match: Match;
  }
  let { match }: Props = $props();
</script>

<section class="screen active" aria-label="Toss">
  <div class="body" style="text-align:center">
    <div class="coin">{match.youWonToss ? 'WON' : 'LOST'}</div>
    <h2>{match.youWonToss ? 'You won the toss' : `${match.opponent.name} won the toss`}</h2>

    {#if match.youWonToss}
      <p class="muted">
        Chasing wins about 55% of real matches — but you'll be batting on whatever your bowlers
        leave you.
      </p>
    {:else}
      <p class="muted">
        They chose to {match.cpuElected === 'FIELD' ? 'bowl' : 'bat'} first.
      </p>
    {/if}

    <div class="card" style="margin-top:var(--space-5);text-align:left">
      <p class="eyebrow" style="margin:0 0 3px">Opponent</p>
      <p style="margin:0" class="opp-team">{match.opponent.name}</p>
    </div>
  </div>

  <div class="actions">
    {#if match.youWonToss}
      <div class="row2">
        <button class="btn-go" onclick={() => match.decideToss(true)}>Bat first</button>
        <button class="btn-secondary" onclick={() => match.decideToss(false)}>Bowl first</button>
      </div>
    {:else}
      <button class="btn-primary" onclick={() => match.decideToss(false)}>
        {match.cpuElected === 'FIELD' ? 'Take strike' : 'Take the field'}
      </button>
    {/if}
  </div>
</section>
